import { env } from '@/env'
import { useAuthStore } from '@/store/auth.store'
import { usePlayerStore } from '@/store/player.store'
import { PLAYER_COLORS } from '@/utils/player-theme'

export function ErrorScreen() {
  const errorMessage = usePlayerStore((s) => s.errorMessage)
  const clearCredentials = useAuthStore((s) => s.clearCredentials)

  function handleReset() {
    clearCredentials()
    window.location.reload()
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: PLAYER_COLORS.bgDark,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        padding: 40
      }}
    >
      <div style={{ fontSize: 40, fontWeight: 700, color: PLAYER_COLORS.brand, fontFamily: 'monospace' }}>CastIQ</div>

      <div
        style={{
          background: PLAYER_COLORS.errorBg,
          border: `1px solid ${PLAYER_COLORS.errorBorder}`,
          borderRadius: 10,
          padding: 32,
          maxWidth: 480,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <div style={{ color: PLAYER_COLORS.textError, fontSize: 18, fontWeight: 600 }}>Erro de configuração</div>
        <div style={{ color: PLAYER_COLORS.textMuted, fontSize: 14, lineHeight: 1.6 }}>
          {errorMessage ?? 'Ocorreu um erro inesperado. Por favor, re-pareie o dispositivo.'}
        </div>

        <button
          type="button"
          onClick={handleReset}
          style={{
            marginTop: 8,
            background: PLAYER_COLORS.bgCardAlt,
            border: `1px solid ${PLAYER_COLORS.borderSubtle}`,
            borderRadius: 8,
            color: '#aaa',
            padding: '10px 20px',
            fontSize: 13,
            cursor: 'pointer'
          }}
        >
          Resetar e parear novamente
        </button>
      </div>

      <div style={{ color: PLAYER_COLORS.border, fontSize: 11, fontFamily: 'monospace' }}>
        v{env.VITE_PLAYER_RELEASE}
      </div>
    </div>
  )
}
